module.exports = __webpack_public_path__ + "img/c80f883.jpg";